<template>
  <div class="prizes-2021-promo-product">
    <div class="prizes-2021-promo-product__preview">
      <img
        :src="product.preview"
        alt=""
        class="prizes-2021-promo-product__img"
      />
    </div>
    <div class="prizes-2021-promo-product__name" v-html="product.name"></div>
  </div>
</template>

<script>
export default {
  name: "Prizes2021PromoProduct",
  props: {
    /** @type {<{name: string, preview: string, href?: string}>} */
    product: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss">
.prizes-2021-promo-product {
  width: 120px;

  text-align: center;

  &__preview {
    width: 120px;
    height: 120px;
    margin-bottom: 10px;

    position: relative;

    &::before,
    &::after {
      content: "";
      position: absolute;
      border-radius: 50%;
    }

    &::before {
      border: 3px solid rgba(#202e5d, 0.2);
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }

    &::after {
      border: 3px solid rgba(#202e5d, 0.4);
      top: 6px;
      bottom: 6px;
      left: 6px;
      right: 6px;
    }
  }

  &__img {
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: calc(100% + 10px);
    max-height: calc(100% + 10px);
  }

  &__name {
    font-size: 13px;
    font-weight: 300;
  }
}
</style>
